import Image from "mui-image";

const CustomeImage = ({ src, alt, style = {}, ...props }) => {
  return <Image src={src} alt={alt} style={style} {...props}></Image>;
};
export default CustomeImage;
